var FundingMethodStatus = /* @__PURE__ */ ((FundingMethodStatus2) => {
  FundingMethodStatus2["Active"] = "active";
  FundingMethodStatus2["Inactive"] = "inactive";
  return FundingMethodStatus2;
})(FundingMethodStatus || {});
var FundingMethodType = /* @__PURE__ */ ((FundingMethodType2) => {
  FundingMethodType2["Deposit"] = "deposit";
  FundingMethodType2["Withdraw"] = "withdraw";
  FundingMethodType2["Adjustment"] = "adjustment";
  FundingMethodType2["Transfer"] = "transfer";
  FundingMethodType2["Promotion"] = "promotion";
  FundingMethodType2["Turnover"] = "turnover";
  FundingMethodType2["CreditLoss"] = "credit-loss";
  FundingMethodType2["ReferralBonus"] = "referral-bonus";
  return FundingMethodType2;
})(FundingMethodType || {});
var FundingMethod = /* @__PURE__ */ ((FundingMethod2) => {
  FundingMethod2["DailyBonus"] = "daily-bonus";
  FundingMethod2["InstantCashBack"] = "cash-back-instant";
  FundingMethod2["DailyCashBack"] = "cash-back-daily";
  FundingMethod2["WeeklyCashBack"] = "cash-back-weekly";
  FundingMethod2["MonthlyCashBack"] = "cash-back-monthly";
  FundingMethod2["ReferralCommission"] = "referral-commission";
  FundingMethod2["ExternalBonus"] = "external-bonus";
  FundingMethod2["ReferralToken"] = "referral-token";
  FundingMethod2["SkinnerBox"] = "skinner-box";
  FundingMethod2["Compensation"] = "compensation";
  FundingMethod2["PlaySpin"] = "play-spin";
  FundingMethod2["MegaShare"] = "mega-share";
  return FundingMethod2;
})(FundingMethod || {});
var FundingMethodDepositMethod = /* @__PURE__ */ ((FundingMethodDepositMethod2) => {
  FundingMethodDepositMethod2["BankTransfer"] = "bank-transfer";
  FundingMethodDepositMethod2["BankTransferNative"] = "bank-transfer-native";
  FundingMethodDepositMethod2["BankTransferZero"] = "bank-transfer-zero";
  FundingMethodDepositMethod2["CardPayment"] = "card-payment";
  FundingMethodDepositMethod2["FastPayment"] = "fast-payment";
  FundingMethodDepositMethod2["LinePay"] = "line-pay";
  FundingMethodDepositMethod2["PromptPay"] = "prompt-pay";
  FundingMethodDepositMethod2["QrCard"] = "qr-card";
  FundingMethodDepositMethod2["QrCode"] = "qr-code";
  FundingMethodDepositMethod2["TrueMoney"] = "true-money";
  FundingMethodDepositMethod2["TrueMoneyQrCode"] = "true-money-qr-code";
  return FundingMethodDepositMethod2;
})(FundingMethodDepositMethod || {});
var FundingMethodWithdrawMethod = /* @__PURE__ */ ((FundingMethodWithdrawMethod2) => {
  FundingMethodWithdrawMethod2["AirPay"] = "air-pay";
  FundingMethodWithdrawMethod2["BankTransfer"] = "bank-transfer";
  FundingMethodWithdrawMethod2["Dolfin"] = "dolfin";
  FundingMethodWithdrawMethod2["LinePay"] = "line-pay";
  FundingMethodWithdrawMethod2["TrueMoney"] = "true-money";
  return FundingMethodWithdrawMethod2;
})(FundingMethodWithdrawMethod || {});
var FundingMethodKey = /* @__PURE__ */ ((FundingMethodKey2) => {
  FundingMethodKey2["GtrQr"] = "gtrpay/qr-code";
  FundingMethodKey2["GtrBank"] = "gtrpay/bank-transfer";
  FundingMethodKey2["TopQr"] = "toppay/qr-code";
  FundingMethodKey2["TopBank"] = "toppay/bank-transfer";
  FundingMethodKey2["TopBankNative"] = "toppay/bank-transfer-native";
  FundingMethodKey2["AiBankTransfer"] = "aipay/bank-transfer";
  FundingMethodKey2["AiQrCode"] = "aipay/qr-code";
  FundingMethodKey2["AiTrueMoney"] = "aipay/true-money";
  FundingMethodKey2["AiTrueMoneyQrCode"] = "aipay/true-money-qr-code";
  FundingMethodKey2["VcTrueMoney"] = "vcpay/true-money";
  FundingMethodKey2["VcPromptPay"] = "vcpay/prompt-pay";
  FundingMethodKey2["VcLinePay"] = "vcpay/line-pay";
  FundingMethodKey2["VcQrCode"] = "vcpay/qr-code";
  FundingMethodKey2["VcQrCard"] = "vcpay/qr-card";
  FundingMethodKey2["VcBank"] = "vcpay/bank-transfer";
  FundingMethodKey2["PapayaBankTransfer"] = "papaya/bank-transfer";
  FundingMethodKey2["PapayaQrCode"] = "papaya/qr-code";
  FundingMethodKey2["PapayaTrueMoney"] = "papaya/true-money";
  FundingMethodKey2["WePayBankTransfer"] = "wepay/bank-transfer";
  FundingMethodKey2["WePayQrCode"] = "wepay/qr-code";
  FundingMethodKey2["EtPayQrCode"] = "etpay/qr-code";
  FundingMethodKey2["EtPayBankTransfer"] = "etpay/bank-transfer";
  FundingMethodKey2["EtPayFastPayment"] = "etpay/fast-payment";
  FundingMethodKey2["EtPayTrueMoney"] = "etpay/true-money";
  FundingMethodKey2["HpPayBankTransfer"] = "hppay/bank-transfer";
  FundingMethodKey2["HpPayPromptPay"] = "hppay/prompt-pay";
  FundingMethodKey2["HsPayBankTransfer"] = "hspay/bank-transfer";
  FundingMethodKey2["HsPayBankTransferNative"] = "hspay/bank-transfer-native";
  FundingMethodKey2["HsPayBankTransferZero"] = "hspay/bank-transfer-zero";
  FundingMethodKey2["HsPayPromptPay"] = "hspay/prompt-pay";
  FundingMethodKey2["HtPayQrCode"] = "htpay/qr-code";
  FundingMethodKey2["HtPayTrueMoney"] = "htpay/true-money";
  FundingMethodKey2["HtPayLinePay"] = "htpay/line-pay";
  FundingMethodKey2["HtPayCardPayment"] = "htpay/card-payment";
  FundingMethodKey2["HtPayBankTransfer"] = "htpay/bank-transfer";
  FundingMethodKey2["HtPayDolfin"] = "htpay/dolfin";
  FundingMethodKey2["HtPayAirPay"] = "htpay/air-pay";
  FundingMethodKey2["SpPayTrueMoney"] = "sppay/true-money";
  FundingMethodKey2["SpPayPromptPay"] = "sppay/prompt-pay";
  FundingMethodKey2["SpPayBankTransfer"] = "sppay/bank-transfer";
  FundingMethodKey2["SsPayBankTransfer"] = "sspay/bank-transfer";
  FundingMethodKey2["SsPayBankTransferZero"] = "sspay/bank-transfer-zero";
  FundingMethodKey2["SsPayBankTransferNative"] = "sspay/bank-transfer-native";
  FundingMethodKey2["JyPayQrCode"] = "jypay/qr-code";
  FundingMethodKey2["JyPayTrueMoney"] = "jypay/true-money";
  FundingMethodKey2["JyPayBankTransfer"] = "jypay/bank-transfer";
  FundingMethodKey2["JyPayPromptPay"] = "jypay/prompt-pay";
  FundingMethodKey2["AzPayQrCode"] = "azpay/qr-code";
  FundingMethodKey2["AzPayBankTransfer"] = "azpay/bank-transfer";
  FundingMethodKey2["AzPayBankTransferZero"] = "azpay/bank-transfer-zero";
  FundingMethodKey2["WtPayBankTransfer"] = "wtpay/bank-transfer";
  FundingMethodKey2["WtPayBankTransferNative"] = "wtpay/bank-transfer-native";
  FundingMethodKey2["WtPayPromptPay"] = "wtpay/prompt-pay";
  FundingMethodKey2["MintDeposit"] = "mint/simulate-deposit";
  return FundingMethodKey2;
})(FundingMethodKey || {});
export {
  FundingMethod,
  FundingMethodDepositMethod,
  FundingMethodKey,
  FundingMethodStatus,
  FundingMethodType,
  FundingMethodWithdrawMethod
};
